import { render, staticRenderFns } from "./Camera.vue?vue&type=template&id=128e5c14&"
import script from "./Camera.vue?vue&type=script&lang=ts&"
export * from "./Camera.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports